/* 🤖 this file was generated by svg-to-ts */
export const DfIconCoins16: {
  name: 'coins-16';
  data: string;
} = {
  name: 'coins-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10.355 5.489a15.73 15.73 0 0 0 4.464-.462A.951.951 0 0 1 16 5.95v.514a1 1 0 0 1-.74.965 16.467 16.467 0 0 1-3.553.558 6.985 6.985 0 0 0-1.352-2.498zm1.625 3.982c.946-.06 1.892-.209 2.838-.445A.951.951 0 0 1 16 9.95v.514a1 1 0 0 1-.74.965 16.468 16.468 0 0 1-3.546.557 7.002 7.002 0 0 0 .266-2.515zm-.982-5.47C8.732 4 6 2.997 6 2.497S8.732 1 10.998 1c2.267 0 4.998.997 4.998 1.498S13.265 4 10.998 4zM5 14.997a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/></svg>`
};
